import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-sql"
      }}>{`with all_tickets as(
    select
        count() as total_tickets
    from zendesk_tickets
    where created_at >= toStartOfDay(now()) - interval 6 month
)

select
    toHour(toTimeZone(created_at, 'UTC')) as hour_of_day,
    count() as count_per_hour,
    count_per_hour/(select total_tickets from all_tickets) as percentage_per_hour
from zendesk_tickets
where created_at >= toStartOfDay(now()) - interval 6 month
group by hour_of_day
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      